
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ShieldCheck } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section className="section-padding relative overflow-hidden bg-brand-darkgrey text-white">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-blue rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-brand-yellow rounded-full blur-[100px]" />
      </div>

      <div className="container-custom relative z-10 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-6xl font-extrabold leading-tight"
          >
            Reduce your dependency on costly and slow database subscriptions
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl text-white/70 max-w-3xl mx-auto"
          >
            In 15 mins, we will help you decide if Cutshort can help you hire faster without increasing your spend.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="pt-6"
          >
            <Button 
              asChild
              size="lg" 
              className="h-16 px-12 text-xl font-bold bg-brand-blue hover:bg-brand-blue/90 rounded-2xl shadow-xl shadow-brand-blue/30 transition-transform hover:scale-105 active:scale-95"
            >
              <a href="https://share.hsforms.com/1y0l7U0OHRo2JLsKVJLBhnAbpcum" target="_blank" rel="noopener noreferrer">
                Book a demo
              </a>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
